import cn from 'classnames'
import { getStatusBadgeLabel } from './StatusBadge.helper'

import './statusBadge.scss'

type StatusBadgeProps = {
  status: string
}

const StatusBadge = ({ status }: StatusBadgeProps) =>
  status ? (
    <div className={cn('report-status-badge-container', status.toLowerCase())}>
      <span className='label'>{getStatusBadgeLabel(status)}</span>
    </div>
  ) : null

export default StatusBadge
